<ag-grid-angular *ngIf="gridActivated" style="width: 100%; height: calc(100% - 35px); margin-top: 4px;"
    [gridOptions]="gridOptions" [ngClass]="agGridTheme" [rowData]="projects" [columnDefs]="cols"
    [defaultColDef]="defaultColDef" rowSelection="single" (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged()" (dragover)="dragover($event)" (dragleave)="dragEnd($event)"
    (drop)="drop($event)">
</ag-grid-angular>